module.exports = __webpack_public_path__ + "media/images/iphonex_splash-c6c3e2dc3740facadefec6b77924765e.png";